import ApplicationController from './application_controller';

// Shows the "maximum" field (visits / units / minutes) that matches the selected
// tracking type on the patient authorization form, and hides the others.
export default class extends ApplicationController {
  static targets = ['select', 'field'];

  connect() {
    this.update();
  }

  update(event) {
    const selected = event?.detail?.value ?? this.selectedValue;
    this.fieldTargets.forEach((field) => {
      field.hidden = field.dataset.trackingType !== selected;
    });
  }

  // The select is an `<awc-autocomplete>` custom element; read its committed
  // value from the hidden input so this works even before the element upgrades.
  get selectedValue() {
    const hiddenField = this.selectTarget.querySelector('input[data-behavior="hidden-field"]');
    return hiddenField ? hiddenField.value : this.selectTarget.value;
  }
}
